@if (loading) {
  <app-loading-spinner />
} @else {
  @if (legalEntity) {
    <div class="mt-8 mx-8 lg:mx-32  gap-4 flex flex-col lg:flex-row lg:justify-center">
      <div class="flex flex-col justify-between mt-4 rounded-xl py-4 px-8 shadow bg-white w-full lg:w-[50%]">
        <div>
          <div class="customer-client-header">
            {{ denyExtendConsent || denyPreferredDealer ? 'Ablehnen?'
            : confirmExtendConsent ? 'Neuen Vertragspartner hinzufügen?'
              : confirmPreferredDealer ? 'Bevorzugten Vertragspartner ändern?'
                : 'Einwilligen?' }}
          </div>
          <div class="mt-8">
            @if (!done) {
              @if (denyExtendConsent) {
                <span>
                  Wenn Sie ablehnen, wird Ihre bestehende Einwilligung nicht auf den anfragenden
                  Toyota-Vertragspartner erweitert. Dieser kann Ihnen dann bestimmte Informationen nicht zusenden.
                </span>
              } @else if (denyPreferredDealer) {
                <span>
                  Wenn Sie ablehnen, bleibt Ihr betreuender Toyota-Vertragspartner unverändert. Der anfragende
                  Toyota-Vertragspartner kann Ihnen dann bestimmte Informationen nicht zusenden.
                </span>
              } @else if (confirmExtendConsent) {
                <span>
                  Bitte bestätigen Sie die Erweiterung ihrer Einwilligung auf den neuen Vertragspartner.
                </span>
              } @else if (confirmPreferredDealer) {
                <span>
                  Bitte bestätigen Sie die Änderung ihres bevorzugten Vertragspartners.
                </span>
              } @else {
                <span>Bitte bestätigen Sie Ihre Einwilligung(en).</span>
              }
            } @else {
              @if (success) {
                <span class="font-semibold text-success">Vielen Dank für Ihre Rückmeldung</span>
              } @else {
                <span class="font-semibold  text-warning">Der Link war bereits abgelaufen</span>
              }
            }
          </div>

          @if (!done) {
            <div
              class="{{ denyExtendConsent || denyPreferredDealer ? 'lg:flex-row lg:flex-row-reverse flex-col-reverse' : 'lg:flex-row' }} flex flex-col mt-5 lg:space-x-5 lg:justify-center gap-4"
            >
              <button
                class="{{ denyExtendConsent || denyPreferredDealer ? 'text-g-gray-400 hover:bg-gray-400' : 'text-toyotaRed hover:bg-toyotaRed' }} bg-white font-bold border rounded-full px-2 py-1 hover:text-white hover:font-bold"
                (click)="confirm()"
                [disabled]="inProgress"
              >
                @if (confirmInProgress) {
                  <app-activity-spinner />
                }
                {{ denyExtendConsent ? 'Erweiterung doch akzeptieren'
                : denyPreferredDealer ? 'Neuen betreuenden Vertragspartner doch akzeptieren'
                  : 'Bestätigen' }}
              </button>

              <button
                class="{{ denyExtendConsent || denyPreferredDealer ? 'text-toyotaRed hover:bg-toyotaRed' : 'text-g-gray-400 hover:bg-gray-400' }} bg-white font-bold border rounded-full px-2 py-1 hover:text-white hover:font-bold"
                (click)="deny()"
                [disabled]="inProgress"
              >
                @if (denyInProgress) {
                  <app-activity-spinner />
                }
                {{ denyExtendConsent ? 'Weiteren Händler ablehnen'
                : denyPreferredDealer ? 'Wechsel ablehnen'
                  : 'Ablehnen'
                }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
}
